import React, { Component } from "react";
import { Switch } from "antd";

export default class MultiSwitch extends Component {
  static get defaultProps() {
    return {
      onChange: function(value) {}
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      selectedOption: props.selectedValue || props.vals[0]
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.selectedOption !== nextProps.selectedValue) {
      this.setState({ selectedOption: nextProps.selectedValue });
    }
  }

  render() {
    let { labels, vals, customClass } = this.props;

    let { selectedOption } = this.state;

    if (!labels || labels.length === 0) {
      return null;
    }

    let returnDiv = [];
    for (let i = 0; i < labels.length; i++) {
      returnDiv.push(
        <li key={`switch-${vals[i]}`} id={"roleSwitch"} className="switch">
          <span className={customClass}>{labels[i]}</span>
          <div className="switch-container">
            <label>
              <Switch
                checked={
                  Array.isArray(selectedOption)
                    ? false
                    : selectedOption === vals[i]
                }
                onChange={() => this.handleChange(vals[i])}
              />
            </label>
          </div>
        </li>
      );
    }

    return <ul>{returnDiv}</ul>;
  }

  handleChange(e) {
    this.setState({ selectedOption: e });
    this.props.onChange(e);
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Switch/MultiSwitch.js